<template>
  <div class="dashboard-container" id="food-app">
    <div class="container">
      <div class="tableBar">
        <el-input
          v-model="input"
          placeholder="请输入订单食物名称"
          style="width: 250px"
          clearable
          @keyup.enter="handleQuery"
        >
          <i
            slot="prefix"
            class="el-input__icon el-icon-search"
            style="cursor: pointer"
            @click="init"
          ></i>
        </el-input>

        <el-button type="danger" @click="sousuo"> 搜索</el-button>

        <!-- <el-button type="primary" @click="addDorm"> 新增宿舍管理员信息</el-button> -->


      </div>



    <!-- 订单表格 -->
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="id" label="ID" width="60"></el-table-column>
      <el-table-column prop="foodName" label="美食名称"></el-table-column>
      <el-table-column prop="price" label="单价"></el-table-column>
      <el-table-column prop="num" label="数量"></el-table-column>
      <el-table-column prop="addr" label="配送地址"></el-table-column>
      <el-table-column prop="phone" label="下单人电话"></el-table-column>
      <el-table-column prop="createTime" label="下单时间"></el-table-column>
      <el-table-column prop="byeName" label="下单人用户"></el-table-column>
      <el-table-column prop="status" label="订单状态">
        <template #default="scope">
          {{ getStatusText(scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column prop="image" label="商品照片">
        <template #default="scope">
          <img :src="scope.row.image" alt="商品照片" style="max-width: 200px;" />
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.row)">改变订单状态</el-button>
          <!-- <el-button size="mini" type="danger" @click="handleDelete( scope.row)">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>
      <el-pagination
        class="pageList"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="counts"
        @size-change="handleSizeChange"
        v-model:current-page="page"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog  v-model="dialogTableVisible">
      <el-form :model="form" label-width="80px">
        <el-form-item label="书籍名称">
          <el-input v-model="form.bookName"></el-input>
        </el-form-item>
        <el-form-item label="单价">
          <el-input v-model="form.price"></el-input>
        </el-form-item>
        <el-form-item label="数量">
          <el-input v-model="form.num"></el-input>
        </el-form-item>
        <el-form-item label="配送地址">
          <el-input v-model="form.addr"></el-input>
        </el-form-item>
        <el-form-item label="下单人电话">
          <el-input v-model="form.linkPhone"></el-input>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select v-model="form.status" placeholder="请选择订单状态">
            <el-option label="待发货" value="0"></el-option>
            <el-option label="发货中" value="1"></el-option>
            <el-option label="已完成" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="书籍照片">
          <el-upload
            action="https://jsonplaceholder.typicode.com/posts/"
            :on-success="handleUploadSuccess"
            :before-upload="beforeUpload"
            list-type="picture-card"
            :limit="1"
            :file-list="fileList"
            :on-remove="handleRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>


  </div>


</template>

<script>
import axios from "axios";





export default {
  name: 'Manage',
  data() {
    return {
      tableData: [],
      typeNameArr: [],
      pagesize:10,
      page:1,
      input: '',
      counts:0,
      msg:"",
      dialogTableVisible:false,
      form: {
        id: null,
        bookName: '',
        price: null,
        num: null,
        addr: '',
        linkPhone: '',
        createTime: null,
        status: '',
        image: ''
      },
      fileList: []
    }
  },



  mounted() {
    this.init()
  },
  methods: {

    init(){
      const params = {
        page: this.page,
        pagesize: this.pagesize,
        input: this.input ? this.input : undefined
      }


      axios.get('http://localhost:8090/mer/getMyOrder',{
          params
        }
      )
        .then(response => {

          this.tableData=response.data.data.records
          this.counts=response.data.data.total
          // 请求成功时的处理逻辑
          console.log(this.tableData)

        })
        .catch(error => {
          // 请求失败时的处理逻辑
          console.error(error); // 输出错误信息
        });
    },

    //点击搜索执行方法即可
    sousuo(){
      this.init();

    },
    

    handleUploadSuccess(){
      this.init();

    },
    
    addDorm(){
      this.msg="新增"
      this.dialogTableVisible=!this.dialogTableVisible
    },

//打开修改窗口

beforeUpload(file) {
      const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJPGOrPNG) {
        this.$message.error('只能上传 JPG 或 PNG 格式的图片!');
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB!');
      }
      return isJPGOrPNG && isLt2M;
    },
    changeHandle(data){
      this.msg="修改"
        this.adminmsg=data
      this.dialogTableVisible=!this.dialogTableVisible
    },

    handleRemove(file, fileList) {
      this.form.image = '';
      this.fileList = fileList;
    },

    submitForm(data){
      if(this.msg=="修改"){
        this.$confirm('确认修改该寝室管理员信息, 是否继续?', '确定修改', {
    'confirmButtonText': '确定',
    'cancelButtonText': '取消',
  }).then(()=>{
    axios.post('http://localhost:8090/sysOrders/update',data)
      .then(response => {
        // 请求成功时的处理逻辑
        this.$message.success("修改成功！")
        this.dialogTableVisible=false
            this.init();
      })
      .catch(error => {
        // 请求失败时的处理逻辑
        console.error(error); // 输出错误信息
      });
  })
      }
else{
  this.$confirm('确认新增该寝室管理员信息, 是否继续?', '确定新增', {
    'confirmButtonText': '确定',
    'cancelButtonText': '取消',
  }).then(()=>{
    axios.post('http://localhost:8090/sysOrders/add',data)
      .then(response => {
        // 请求成功时的处理逻辑
        this.$message.success("新增成功！")
        this.dialogTableVisible=false
        this.init();
      })
      .catch(error => {
        // 请求失败时的处理逻辑
        console.error(error); // 输出错误信息
      });
  })
} 
},

getStatusText(status) {
      const statusMap = { 0: '待发货', 1: '发货中', 2: '已完成' };
      return statusMap[status];
    },

    addFoodtype(){
      console.log(666)
    },
    handleQuery(){
      console.log(666)
    },


    handleEdit(data){
      this.$confirm('确认修改该订单状态信息, 是否继续?', '确定修改', {
        'confirmButtonText': '确定',
        'cancelButtonText': '取消',
      }).then(()=>{
        axios.get('http://localhost:8090/order/changeStatus?id='+data.id)
          .then(response => {
            // 请求成功时的处理逻辑
            this.$message.success("修改成功！")
            this.dialogTableVisible=false
            this.init();
          })
          .catch(error => {
            // 请求失败时的处理逻辑
            console.error(error); // 输出错误信息
          });
      })
    },
    // 全部操作
    handleSelectionChange (val){
      let checkArr = []
      val.forEach((n) => {
        checkArr.push(n.id)
      })
      this.checkList = checkArr
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange (val) {
      this.page = val
      this.init()
    }

  }
}
</script>

<style lang="less" scoped>
.manage {
  padding: 16px;
}
</style>
